import { BookingAPI } from '@/apis/bookings.api';
import { IBooking } from '@/models/IBooking.model';
import { IPark } from '@/models/IPark.model';
import moment from 'moment';

export default function getBookingHoursByDDMMYYY(cc: string, ddmmyyyy: string, bookings: IBooking[], park: IPark, clientType: string): string[] {
  const hasUserBookedAlready: IBooking[] = bookings.filter(booking => {
    return booking.parkName === park.name &&
      booking.ddmmyyyy === ddmmyyyy &&
      booking.cc_number === cc;
  });

  if (!(hasUserBookedAlready && hasUserBookedAlready.length === 0)) {
    return ['Usuario ya reservo este dia'];
  } else {

    const dayOfTheWeek = moment(ddmmyyyy, 'DDMMYYYY').toDate().getDay();
    const daysOfTheWeeks = [park.weekdays.sunday, park.weekdays.monday, park.weekdays.tuesday, park.weekdays.wednesday, park.weekdays.thursday, park.weekdays.friday, park.weekdays.saturday,];

    const hours = daysOfTheWeeks[dayOfTheWeek].filter(dayOfWeek => {

      const _hour = dayOfWeek.hour;
      const _capacity = parseInt(dayOfWeek.capacity.total + '', 10);
      const _bookingsForHour = bookings.filter(
        (booking: IBooking) =>
          booking.ddmmyyyy === ddmmyyyy &&
          booking.hour === _hour
      )
      return _bookingsForHour.length < 0.95 * _capacity

    }).filter(dayOfWeek => {
      
      
      console.log({
        clientType,
        dayOfWeek,
        out: dayOfWeek.aviableFor.length === 2 ? clientType === 'SCHOOL' : clientType === 'PUBLIC'
      })

      if (dayOfWeek.aviableFor.length === 2) {
        return clientType === 'SCHOOL'
      } else {
        return dayOfWeek.aviableFor[0] === clientType ;
      }

    })

    console.clear();
    console.warn(' ')
    console.warn(' ')
    console.warn('  hours.map(dayOfWeek => dayOfWeek.hour); ')
    console.warn(hours.map(dayOfWeek =>dayOfWeek.hour).filter(hourAsString => {
      const now = moment();
      const hour = moment(hourStringToNumber[hourAsString], "h:mm:ss A");
      const isInFuture = (now.diff(hour) <= 0) // today - future < 0
      return isInFuture;
    }))
    console.warn(' ')


    return hours.map(dayOfWeek => dayOfWeek.hour).filter(hourAsString => {
      const now = moment();
      const hour = moment(hourStringToNumber[hourAsString], "h:mm:ss A");
      const isInFuture = (now.diff(hour) <= 0) // today - future < 0
      return isInFuture || true;
    });
  }
}


const hourStringToNumber = {
  'hour600am_730am': "06:00:00 AM",
  'hour800am_930am': "08:00:00 AM",
  'hour1000am_1130am': "10:00:00 AM",
  'hour1200am_0130pm': "12:'00:00 AM",
  'hour200pm_330pm': "02:00:00 PM",
  'hour400pm_530pm': "04:00:00 PM",
  'hour600am_700am': "06:00:00 PM",
  'hour800am_900am': "08:00:00 AM",
  'hour1000am_1100am': "10:00:00 AM",
  'hour1200am_0100pm': "12:00:00 AM",
  'hour0300pm_0400pm': "03:00:00 PM",
  'hour0500pm_0600pm': "05:00:00 PM",
}


/*


 const dayOfTheWeek = new Date().getDay();
        const daysOfTheWeeks = [
          this.park.weekdays.sunday,
          this.park.weekdays.monday,
          this.park.weekdays.tuesday,
          this.park.weekdays.wednesday,
          this.park.weekdays.thursday,
          this.park.weekdays.friday,
          this.park.weekdays.saturday,
        ]

        const bookings = this.$store.state.bookings;
        const ddmmyyyy = moment(this.date).format('DDMMYYYY');


        const isUserReservedThisDay = bookings.filter(
          (booking: IBooking) => booking.ddmmyyyy === ddmmyyyy
        ).length > 0;

        if(isUserReservedThisDay){
          return [];
        } else {
            return daysOfTheWeeks[dayOfTheWeek]
                      .filter(dayOfWeek => {
                          const _hour = dayOfWeek.hour;
                          const _capacity = parseInt(dayOfWeek.capacity.total + '', 10);
                          const _bookingsForHour = bookings.filter(
                            (booking: IBooking) =>
                                booking.ddmmyyyy === ddmmyyyy &&
                                booking.hour === _hour
                          )
                          return _bookingsForHour.length < 0.9*_capacity
                      })
                      .filter(dayOfWeek => {
                        return true;
                          if(dayOfWeek.aviableFor.length === 2){
                            return this.clientType === 'SCHOOL';
                          }else {
                            return this.clientType === 'PUBLIC';
                          }
                        })
                      .map(dayOfWeek => dayOfWeek.hour);
         }
         */